// extracted by mini-css-extract-plugin
export const socialMediaShare = "social-media-share-module--social-media-share--2qsNN";
export const instagramLink = "social-media-share-module--instagram-link--2VJSb";